import { ReactNode, useRef, useState } from 'react';
import { Placement } from '@floating-ui/react';
import { Tooltip } from './Tooltip';

type Props = {
  children: ReactNode;
  content: string;
  placement?: Placement;
  withArrow?: boolean;
  className?: string;
};

/**
 * HoverTooltip - A reusable wrapper component for hover tooltips
 *
 * Automatically handles mouse enter/leave events to show/hide tooltips.
 * Uses the existing Tooltip component for consistent styling and behavior.
 */
export const HoverTooltip = ({
  children,
  content,
  placement = 'top',
  withArrow = true,
  className,
}: Props) => {
  const anchorRef = useRef<HTMLSpanElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  return (
    <>
      <span
        ref={anchorRef}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        {children}
      </span>
      <Tooltip
        isVisible={isVisible}
        anchorEl={anchorRef.current}
        placement={placement}
        withArrow={withArrow}
        className={className}
      >
        {content}
      </Tooltip>
    </>
  );
};
